import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';
import Navbar from '../Navbar';
import { MdEditSquare } from "react-icons/md";
import Menu_Items from '../Menu_Items';

function Edit_User() {
  const { com_id, id } = useParams();
  const [inval, setinval] = useState({});
  const navigate = useNavigate();

  // First Run 
  const getuser = async () => {
    axios.get(`/user/edit/${id}`).then((res) => {
      setinval(res.data);
    })
      .catch((err) => {
        toast.error('Edit User Details Could not be Fetched', {
          autoClose: 2000, // 2 seconds
        });

      })
  };
  const menus = [
    {
      name: 'Integrations',
      id: com_id
    },
    {
      name: 'Users',
      id: com_id
    }
  ];
  const handledata = (e) => {
    setinval({ ...inval, [e.target.id]: e.target.value });
  };
  const submit = async () => {
    await axios.patch(`/user/edit/${inval.id}`, inval).then((res) => {
      navigate(`/company/users/${com_id}`);

    }).catch((err) => {
      toast.error('Edit User Details Could not be Updated', {
        autoClose: 2000, // 2 seconds
      });
    })

  };
  useEffect(() => {
    getuser();
  }, [])
  return (
    <div className='container df fdc jb ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'><MdEditSquare className='page_icon db' />
              <p>Edit User</p></div>
          </div>
          <div className='box'>
            <div className='create_box '>
              <div>
                <label htmlFor='name'>Name</label>
                <input type='search' id='name' onChange={(e) => { handledata(e) }} value={inval.name ? inval.name : ''} />
              </div>
              <div>
                <label htmlFor='mail'>E-Mail Id</label>
                <input type='search' id='mail' onChange={(e) => { handledata(e) }} value={inval.mail ? inval.mail : ''} />
              </div>
              <div>
                <label htmlFor='mobile'>Mobile No</label>
                <input type='number' id='mobile' onChange={(e) => { handledata(e) }} value={inval.mobile ? inval.mobile : ''} />
              </div>
              <div>
                <label htmlFor='userid'>User Id</label>
                <input type='search' id='uname' onChange={(e) => { handledata(e) }} value={inval.uname ? inval.uname : ''} />
              </div>
              <div>
                <label htmlFor='password'>Password</label>
                <input type='search' id='password' onChange={(e) => { handledata(e) }} value={inval.password ? inval.password : ''} />
              </div>
              <div>
                <label htmlFor='role'>Role</label>
                <select id='role' onChange={(e) => { handledata(e) }} value={inval.role ? inval.role : ''}>
                  <option value={""}>Please Select</option>
                  <option value={'Admin'}>Admin</option>
                  <option value={'Integ User'}>Integ User</option>
                  <option value={'Integ Special'}>Integ Special</option>
                  <option value={'Integ Monitor'}>Integ Monitor</option>
                </select>
              </div>
              <div >
                <label htmlFor='sso'>SSO</label>
                <select id='sso' onChange={(e) => { handledata(e) }} value={inval.sso ? inval.sso : ''}>
                  <option value={""}>Please Select</option>
                  <option value={'yes'}>Yes</option>
                  <option value={'no'}>No</option>
                </select>
              </div>
            </div>
            <div className='w100 h10 df jc ac'>
              <button className='btn green' onClick={submit}>Submit</button>
            </div>
          </div>
        </div>
      </div>

    </div >
  )
}

export default Edit_User;